import { __awaiter } from "tslib";
import consoleEvents from '../../consoleEvents';
import getOptimizelyDefaultOptions from '../getOptimizelyDefaultOptions';
import initOptimizelyVanillaHelpersSDK from '../initOptimizelyVanillaHelpersSDK';
/**
 * Return optimizely vanilla sdk user context.
 * @returns {user context} - optimizely vanilla user context
 */
const initOptimizelyVanillaUsercontext = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let optimizelyVanillaUsercontext;
        if (window.optimizelyVanillaUsercontext) {
            optimizelyVanillaUsercontext = window.optimizelyVanillaUsercontext;
        }
        else {
            if (!window.optimizelyVanillaHelpersSDKInstance) {
                yield initOptimizelyVanillaHelpersSDK();
            }
            const { attributes, userId } = getOptimizelyDefaultOptions();
            optimizelyVanillaUsercontext = window.optimizelyVanillaHelpersSDKInstance.createUserContext(userId, attributes);
            window.optimizelyVanillaUsercontext = optimizelyVanillaUsercontext;
        }
        return optimizelyVanillaUsercontext;
    }
    catch (e) {
        consoleEvents.error('Error with initializing Optimizely Vanilla usercontext ', e);
        return e;
    }
});
export default initOptimizelyVanillaUsercontext;
//# sourceMappingURL=initOptimizelyVanillaUsercontext.js.map